import { render, staticRenderFns } from "./GouvernanceCombobox.vue?vue&type=template&id=28e6341a&"
import script from "./GouvernanceCombobox.vue?vue&type=script&lang=js&"
export * from "./GouvernanceCombobox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports